module.exports = __webpack_public_path__ + "static/img/ALIPAY.f09b785.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ALIPAY.jpg
// module id = Rlcp
// module chunks = 1